import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export interface OpPlusGetHigherDiscountElement extends HTMLElement {
  'product-id': number;
  discount: number;
  alternative?: boolean;
}

const OpPlusGetHigherDiscount = createWrapper<OpPlusGetHigherDiscountElement>('op-plus-get-higher-discount');

export default OpPlusGetHigherDiscount;
